import React from 'react';
export var ImpressionContext = React.createContext(null);
//# sourceMappingURL=impressionContext.js.map